export default String.raw`
$(document).ready(function () {
    searchAdvanced.init();
})

const searchAdvanced = (function () {
    const init = function () {
        validationForCheckboxes();
        events();
    }

    const $container = $(".search-advanced-container");

    // This function clears all inputs from search section
    const clear = () => {
        // To reset all text inputs
        $(".search-advanced-container input[type='search'], .search-advanced-container input[type='number']").val("");
        // To reset custom select
        $(".memory-js").val("");
        $(".selected-js").text($(".select-js li:first-child").text());
        // To reset all checkboxes
        $(".search-advanced-container__find-by input, .search-advanced-container__checkboxes input").prop({ "checked": false, "disabled": false });
        // Becasue of the function above which clears all checkboxes, we must checked default value
        $("#default-search").prop("checked", true);
        // To hide bad price value information
        $(".bad-value-js").addClass("hidden");

        // To scroll to top of the section
        const element = $(".search-advanced-container__search")[0];
        const elementPosition = element.getBoundingClientRect().top;

        window.scrollTo({ top: elementPosition, behavior: "smooth" });
    }

    const disableCheckbox = (toObserve, toDisable, data, element) => {
        const isChecked = $(element).prop("checked");

        $(toDisable + " input").prop("disabled", false);

        if (isChecked) {
            $(toObserve + " input").not(element).prop("checked", false);

            const name = $(element).parent().data("name");
            let brands = data[name];

            if (Object.keys(data).length !== 0) {
                if (brands === undefined) {
                    $(toDisable + " input").prop("disabled", true);
                } else {
                    brands = brands.map((brand) => {
                        return toDisable + "[data-name='"+ brand + "'] input";
                    });

                    $(toDisable + " input").not(brands.toString()).prop("disabled", true);
                }
            }
        }
    }

    const validationForCheckboxes = () => {
        // Get all manufactures and their brands
        const manufactureBrands = {};
        const allManufactures = $(".manufacture");
        for (const manufacture of allManufactures) {
            manufactureBrands[manufacture.dataset.name] = manufacture.dataset.brands.slice(0, -1).split(",");
        }

        // Get all brands and their manufactures
        const brandsMancufacture = {};
        for (const [key, value] of Object.entries(manufactureBrands)) {
            for (const brand of value) {
                if (brand !== "") {
                    if (brandsMancufacture[brand] instanceof Array) {
                        brandsMancufacture[brand].push(key);
                    } else {
                        brandsMancufacture[brand] = [key];
                    }
                }
            }
        }

        const checkedManufacture = $(".manufacture input:checked");
        if (checkedManufacture.length !== 0) {
            disableCheckbox(".manufacture", ".brand", manufactureBrands, checkedManufacture);
        }

        const checkedBrand = $(".brand input:checked");
        if (checkedBrand.length !== 0) {
            disableCheckbox(".brand", ".manufacture", brandsMancufacture, checkedBrand);
        }

        // Dissable all brands that doesn't belong to the chosen manufacture
        $(".manufacture input").on("input", function () {
            disableCheckbox(".manufacture", ".brand", manufactureBrands, this);
        });

        // Disable all manufactures that doesn't belong to the chosen brand
        $(".brand input").on("input", function () {
            disableCheckbox(".brand", ".manufacture", brandsMancufacture, this);
        });
    }

    const search = () => {
        // This whole section collects all data from inputs
        const searchForm = $(".search-advanced-container");

        // From search options
        const searchOption = searchForm.find(".search-advanced-container__find-by div input:checked").attr("value");

        // Contains information about at least one input has value
        let isFilled = false;
        const data = [];

        data.push({ name: '__action', value: 'Get/SearchAdvanced' });

        // From search
        const searchInput = searchForm.find("input[type='search']");
        if (searchInput.val() !== "") {
            data.push({ name: searchOption, value: searchInput.val() });
            isFilled = true;
        }

        // From select
        const select = searchForm.find(".memory-js");
        const selectedValue = select.val();
        if (selectedValue !== "") {
            data.push({ name: "groupId", value: selectedValue });
            isFilled = true;
        }

        // Sets chosen search option
        data.push({ name: "tos", value: searchOption });

        // From prices
        const min = $("#min-price").val();
        const max = $("#max-price").val();
        let isProperValues = true;
        if (min !== "" || max !== "") {
            data.push({ name: "priceFrom", value: min });
            data.push({ name: "priceTo", value: max });
            isFilled = true
        }
        if (parseFloat(min) > parseFloat(max) && (min !== "" && max !== "")) {
            isProperValues = false;
        }

        // From fields
        const fields = searchForm.find("input[name='fields']:checked");
        for (const field of fields) {
            data.push({ name: "fields", value: field.value });
        }

        // From flags
        const flags = searchForm.find("input[name='flags']:checked");
        if (flags.length !== 0) {
            for (const flag of flags) {
                data.push({ name: "flags", value: flag.value });
            }
            isFilled = true;
        }

        // From manufactures
        const manufactureId = searchForm.find("input[name='manufacturerId']:checked");
        if (manufactureId.length !== 0) {
            data.push({ name: "manufacturerId", value: manufactureId.val() });
            isFilled = true;
        }

        // From brands
        const brandId = searchForm.find("input[name='brandId']:checked");
        if (brandId.length !== 0) {
            data.push({ name: "brandId", value: brandId.val() });
            isFilled = true;
        }

        // After collecting data function checks that at least one input is filled and prices inputs are filled correctly
        // Succes will show searching results failure will show right popup
        if (isFilled && isProperValues) {
            $.post(null, data, (res) => {
                const url = res.action.Redirect302;
                window.location.assign(url);
            });
        } else if (!isProperValues) {
            app.temporaryPopupMessage($container, __translations.BadPrice, "warn");
           
        } else {
            app.temporaryPopupMessage($container, __translations.EmptySearch, "warn");
        }
    }

    const events = () => {
        $('#clear-button').on('click', clear);
        $('#search-button').on('click', search);

        $(".search-advanced-container input[type='search']").on("input", (e) => {
            if (e.currentTarget.value.length > 0) {
                $(".clear-search-js").removeClass("hidden-js");
            } else {
                $(".clear-search-js").addClass("hidden-js");
            }
        })

        $(".clear-search-js").on("click", () => {
            $(".search-advanced-container input[type='search']").val("");
            $(".clear-search-js").addClass("hidden-js");
        });

        // When user clicks an enter key the searching will start
        // $(".search-advanced-container").on("keypress", function (e) {
        //     const key = e.which || e.keyCode;
        //     if (key === 13)
        //         search();
        // });

        // It shows information about bad values in price inputs
        $(".search-advanced-container__price input").on("input", function () {
            const min = $("#min-price").val();
            const max = $("#max-price").val();

            if (parseFloat(min) > parseFloat(max) && (min !== "" && max !== "")) {
                $(".bad-value-js").removeClass("hidden");
            } else {
                $(".bad-value-js").addClass("hidden");
            }
        });
    }

    return {
        init: init
    }
})();
`